import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { ReactComponent as SuccessIcon } from 'static/svg/green-check.svg'

import * as S from './styles'

interface MedicalRequestSuccessModalProps {
  onClose: () => void;
}

export function MedicalRequestSuccessModal({
  onClose,
}: MedicalRequestSuccessModalProps): JSX.Element {
  return (
    <ModalGeneric
      modalTitle={
        <S.TitleContainer>
          <SuccessIcon width={50} height={50} />
          <Typography center weight="bold" variant="header4">
            Pedido médico será analisado! Agora é só aguardar a autorização do
            seu convênio.
          </Typography>
        </S.TitleContainer>
      }
      onCloseModal={onClose}
      btnOnClick={onClose}
    >
      <S.SuccessModalContainer>
        <S.AuthorizationContainer>
          Pediremos a autorização junto ao seu convênio e{' '}
          <strong>em até 5 dias úteis</strong> você receberá a confirmação por
          e-mail e SMS.
        </S.AuthorizationContainer>
        <S.FooterDescription>
          Enquanto você aguarda a aprovação, ainda não é possível agendar
          consultas, mas você já pode{' '}
          <a href='/'>
            <strong>conhecer nossos profissionais</strong>
          </a>
          .
        </S.FooterDescription>
      </S.SuccessModalContainer>
    </ModalGeneric>
  )
}
